import React from 'react'
import { profile_sheet_basic_profile_path } from 'routes'
import styles from './ModalFifthView.module.scss'
import ChangeModal from './changeModal'
import Icon from '../../../../../assets/images/invoice/icon_fifth.svg'
import ModalButton from 'spa/member/components/ModalButton'

const ModalFifthView: React.FC<ChangeModal> = (props) => {
  const reload = () => {
    location.reload()
  }
  return (
    <div className={`${styles.overlay} js-modal-overlay`}>
      <div className={`${styles.modalContainer} js-modal-container`}>
        <div className={styles.invoiceIcon}><img src={Icon} /></div>
        <div className={styles.sectionTitle}><p>ご入力ありがとうございます。</p></div>
        <div className={styles.sectionText}>
          <p className={styles.thankyouText}>ご入力ありがとうございました。ご登録内容に変更がある場合は、
            <a className={styles.profileLinkText} href={profile_sheet_basic_profile_path()}>
              基本情報ページ
            </a>
            から変更してください。
          </p>
        </div>
        <div className={styles.sectionBtn}>
          <ModalButton buttonType='NEXT' onClick={reload}>閉じる</ModalButton>
        </div>
      </div>
    </div>
  )
}

export default ModalFifthView
